import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Shared } from '../../service/shared';
import { INAAction } from '../../model/ina-action';
import { Section } from '../model/inaSchoolEnrollments';
import { InaService } from '../../service/ina.service';
import { RelationToChild } from '../../model/relation-To-Child';
import { StepAction } from '../model/stepAction';


import { formatDate } from '@angular/common';
import { TrackingHistories, TrackingHistory } from '../../service/history';


@Component({
  selector: 'app-interviewee',
  templateUrl: './interviewee.component.html',
  styleUrls: ['./interviewee.component.scss']
})



export class IntervieweeComponent implements OnInit {
  @Input('step') step: number = 0;
  @Input('action') action: INAAction;


  @Output() prevOrNextStep = new EventEmitter<StepAction>();
  @Output() valid = new EventEmitter<boolean>();
  @Output() updateHistory = new EventEmitter<TrackingHistory>();

  section: Section;
  public shared: Shared;
  notifyAction: string = '';
  inaStatusTypeId: number;

  frmInterviewee: UntypedFormGroup;
  relationShipData: RelationToChild[] = [];
  lstTrackHistory: TrackingHistory[] = [];
  trackHistories: TrackingHistories = new TrackingHistories();
  constructor(
    private fb: UntypedFormBuilder,
    private inaService: InaService
  ) {
    this.shared = new Shared(inaService);
    this.trackHistories.inaHistory = [];

    this.relationShipData = this.shared.getRelationships();
    this.frmInterviewee = this.fb.group({
      fName: ['', Validators.required],
      lName: ['', Validators.required],
      relationChild: ['', Validators.required],
      intervieweeDate: ['', Validators.required]
    });
  }

  ngAfterViewInit(): void {
    this.fireValidation();
  }
  fireValidation() {
    if (this.action != INAAction.View) {
      if (this.fName.errors?.required || this.lName.errors?.required || this.relationChild.errors?.required || this.intervieweeDate?.required) {
        this.frmInterviewee.setErrors({ required: true, invalid: 'Complete the Interviewee sections' });
      }
      else {
        this.frmInterviewee.setErrors(null);
      }
      let validator: boolean = (this.frmInterviewee.errors?.['required'] == true) ? false : true;
      this.valid.emit(validator);
    }
  }
  ngOnInit(): void {
    let sectionId: number = 28;
    this.inaService.inaSelectionSubject$.subscribe(x => {
      this.section = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == sectionId)!;
      this.inaStatusTypeId = x.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId;
      if (!this.frmInterviewee.dirty)
        this.setFormValue();
    });
    this.inaService.inaHistorySelectionSubject$.subscribe((x: TrackingHistories) => {
      if (x.inaHistory?.length >= 1) {
        this.trackHistories.inaHistory = x.inaHistory.filter(x => x.ChangedField.split(',')[0] == sectionId.toString());
      }

    });

    if (this.action == 3) {
      this.frmInterviewee.disable();
    }

  }


  setFormValue() {
    this.fName.setValue(this.getQuestionValue(488, 'First Name'));
    this.lName.setValue(this.getQuestionValue(489, 'Last Name'));
    this.relationChild.setValue(this.getQuestionValue(490, 'Relation to the child(ren)'));
    this.intervieweeDate.setValue(this.getQuestionValue(491, 'Date'));
  }

  getQuestionValue(questionId: number, questionName: string): string {
    return this.shared.getQuestionValue(this.section, questionId, questionName);
  }

  /*
  setStep(index: number) {
    this.step = index;
    let s: StepAction = new StepAction();
    s.stepNumber = index;
    this.prevOrNextStep.emit(s);
  }


  nextStep() {
    this.notifyAction = 'Next';
    this.notifyChanges(0);
  }

  prevStep() {
    this.notifyAction = 'Prev';
    this.notifyChanges(0);
  }

  notifyChanges(action: number) {
      let s: StepAction = new StepAction();
      s.stepNumber = 11;
      s.action = this.notifyAction;
      s.action = action == 1 ? '': this.notifyAction ;
      this.updateChangeValue();
      s.section = this.section;
      s.lsttrackingHistory = this.lstTrackHistory;
      this.lstTrackHistory=[];
      this.prevOrNextStep.emit(s);
  }*/

  updateChangeValue() {
    //console.log('updateChangeValue');
    //return ;
    this.frmInterviewee.markAsTouched();
    if (this.fName.dirty) {
      //this.fName.markAsPristine();
      this.setListQuestionValue(488, 'First Name', this.fName.value);

    }
    if (this.lName.dirty) {
      //this.lName.markAsPristine();
      this.setListQuestionValue(489, 'Last Name', this.lName.value);

    }
    if (this.relationChild.dirty) {
      //this.relationChild.markAsPristine();
      this.setListQuestionValue(490, 'Relation to the child(ren)', this.relationChild.value);
    }
    if (this.intervieweeDate.dirty) {
      //this.intervieweeDate.markAsPristine();
      this.setListQuestionValue(491, 'Date', this.intervieweeDate.value);
    }
  }

  setListQuestionValue(questionId: number, questionName: string, value: string) {
    let prevValue: string = this.shared.getQuestionValue(this.section, questionId, questionName);
    if (prevValue != value) {
      this.setTrackingHistory(questionId, questionName, value);
      this.shared.setListQuestionValue(this.section, questionId, questionName, value);

    }
    this.fireValidation();
  }
  setTrackingHistory(questionId: number, questionName: string, value: string) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTrackingHistory(this.section, questionId, questionName, value);
      this.updateHistory.emit(tempTrackingHistory);
    }
  }


  populateNameDate() {
    /*let u: User = this.loginTokenService.getUser();
    this.fName.setValue(u?.PERSON?.FIRST_NAME);
    this.lName.setValue(u?.PERSON?.LAST_NAME);*/
    this.intervieweeDate.setValue(formatDate(new Date(), 'MM/dd/yyyy', 'en'));
    this.intervieweeDate.markAsDirty();
    this.updateChangeValue();
  }
  clearNameDate() {
    this.fName.setValue('');
    this.fName.markAsDirty();

    this.lName.setValue('');
    this.lName.markAsDirty();

    this.relationChild.setValue('');
    this.relationChild.markAsDirty();

    this.intervieweeDate.setValue('');
    this.intervieweeDate.markAsDirty();

    this.updateChangeValue();
  }
  copySignature(constentName: string) {
    if (constentName == 'g1' || constentName == 'g2') {
      this.inaService.inaSelectionSubject$.subscribe(x => {
        let parentSection = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == 19)!;
        let name: string = ' ';
        let relationShip: string = '';
        if (constentName == 'g1') {
          name = this.getQuestionValueFromDifferentSection(parentSection, 318, 'Current Parent/Guardian 1');
          relationShip = this.getQuestionValueFromDifferentSection(parentSection, 319, 'Relationship 1');
        }
        else {
          name = this.getQuestionValueFromDifferentSection(parentSection, 321, 'Current Parent/Guardian 2');
          relationShip = this.getQuestionValueFromDifferentSection(parentSection, 322, 'Relationship 2');
        }
        this.fName.setValue(name.split(",")[1])
        this.lName.setValue(name.split(",")[0])
        this.relationChild.setValue(relationShip);
      });
    }
    if (constentName == 'osy') {
      this.inaService.inaSelectionSubject$.subscribe(x => {
        let personalSection = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == 18)!;
        let name: string = this.getQuestionValueFromDifferentSection(personalSection, 300, 'Name')

        this.fName.setValue(name.split(",")[1])
        this.lName.setValue(name.split(",")[0])
        this.relationChild.setValue('self');
      });

    }

    this.fName.markAsDirty();
    this.lName.markAsDirty();
    this.relationChild.markAsDirty();
    this.intervieweeDate.markAsDirty();

    this.updateChangeValue();
  }
  getQuestionValueFromDifferentSection(sec: Section, questionId: number, questionName: string): string {
    return this.shared.getQuestionValue(sec, questionId, questionName);
  }

  get fName(): any { return this.frmInterviewee.get('fName'); }
  get lName(): any { return this.frmInterviewee.get('lName'); }
  get intervieweeDate(): any { return this.frmInterviewee.get('intervieweeDate'); }
  get relationChild(): any { return this.frmInterviewee.get('relationChild'); }

}


